import { render, staticRenderFns } from "./TemplateContent.vue?vue&type=template&id=5b42265b&"
import script from "./TemplateContent.vue?vue&type=script&lang=ts&"
export * from "./TemplateContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports